import React from 'react';
import PropTypes from 'prop-types';

const TrustpilotStars = ({ theme }) =>
  theme === 'minimal' ? (
    <svg
      width="99"
      height="18"
      viewBox="0 0 99 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59717 0.00012207L11.6178 6.21897H18.1567L12.8666 10.0624L14.8872 16.2813L9.59717 12.4378L4.3071 16.2813L6.32773 10.0624L1.03766 6.21897H7.57654L9.59717 0.00012207Z"
        fill="#0D0D0D"
      />
      <path
        d="M29.5972 0.00012207L31.6178 6.21897H38.1567L32.8666 10.0624L34.8872 16.2813L29.5972 12.4378L24.3071 16.2813L26.3277 10.0624L21.0377 6.21897H27.5765L29.5972 0.00012207Z"
        fill="#0D0D0D"
      />
      <path
        d="M49.5972 0.00012207L51.6178 6.21897H58.1567L52.8666 10.0624L54.8872 16.2813L49.5972 12.4378L44.3071 16.2813L46.3277 10.0624L41.0377 6.21897H47.5765L49.5972 0.00012207Z"
        fill="#0D0D0D"
      />
      <path
        d="M69.5972 0.00012207L71.6178 6.21897H78.1567L72.8666 10.0624L74.8872 16.2813L69.5972 12.4378L64.3071 16.2813L66.3277 10.0624L61.0377 6.21897H67.5765L69.5972 0.00012207Z"
        fill="#0D0D0D"
      />
      <path
        d="M92.6315 9.61521L92.6315 9.61522C92.4212 9.768 92.3332 10.0388 92.4135 10.286L93.9362 14.9723L89.9498 12.076C89.9498 12.076 89.9498 12.076 89.9498 12.076C89.7395 11.9232 89.4548 11.9232 89.2445 12.076L85.2582 14.9723L86.7808 10.286L86.3053 10.1315L86.7808 10.286C86.8611 10.0388 86.7731 9.768 86.5628 9.61522L86.2689 10.0197L86.5628 9.61521L82.5765 6.71897H87.5039C87.7638 6.71897 87.9942 6.55159 88.0745 6.30438L89.5972 1.61816L91.1198 6.30438L91.5953 6.14987L91.1198 6.30438C91.2001 6.55159 91.4305 6.71897 91.6904 6.71897H96.6178L92.6315 9.61521Z"
        stroke="#0D0D0D"
      />
    </svg>
  ) : (
    <svg fill="none" width="100" viewBox="100 0 100 24">
      <g fill="var(--sah-primary)" fillRule="evenodd">
        <path d="M102 5.373h18.188v18H102v-18zm11.86 11.438l-2.766.693 3.921 2.831-1.155-3.525zm-1.27-3.863h4.869l-3.921 2.812-2.425 1.725-3.941 2.813 1.497-4.537-3.941-2.813h4.869l1.497-4.538 1.496 4.538zM121.7 5.373h18.188v18H121.7v-18zm11.86 11.438l-2.766.693 3.922 2.831-1.156-3.525zm-1.269-3.863h4.869l-3.922 2.812-2.425 1.725-3.941 2.813 1.497-4.537-3.941-2.813h4.869l1.497-4.538 1.497 4.538zM141.41 5.373h18.188v18H141.41v-18zm11.86 11.438l-2.766.693 3.922 2.831-1.156-3.525zm-1.269-3.863h4.869l-3.922 2.812-2.425 1.725-3.941 2.813 1.497-4.537-3.941-2.813h4.869l1.497-4.538 1.497 4.538zM161.11 5.373h18.188v18H161.11v-18zm11.86 11.438l-2.766.693 3.922 2.831-1.156-3.525zm-1.269-3.863h4.869l-3.922 2.812-2.425 1.725-3.941 2.813 1.497-4.537-3.94-2.813h4.868l1.497-4.538 1.497 4.538zM180.81 5.373h9.094v3.038l-1.496 4.537h-4.869l3.94 2.813-1.496 4.537 3.921-2.799v5.874h-9.094v-18z" />
      </g>
    </svg>
  );

TrustpilotStars.propTypes = {
  theme: PropTypes.oneOf(['dark', 'light', 'minimal']).isRequired
};

export default TrustpilotStars;
